import { useEffect, useState, useRef, useCallback } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { listActivityTypes } from 'services/timerServices';

const useActivityTypes = (initialFilters = {}, skipInitialLoad = false, excludeFromLoading = false) => {
  const [activityTypes, setActivityTypes] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const initialFiltersRef = useRef(initialFilters);

  useEffect(() => {
    initialFiltersRef.current = initialFilters;
  }, [initialFilters]);

  const loadActivityTypes = useCallback(
    async (practiceAreaIds = null) => {
      try {
        const count = totalCount || (await totalCountEvent('activity_type'))?.data;
        if (!count) return;

        setTotalCount(count);

        const filters = { ...initialFiltersRef.current };
        if (practiceAreaIds && practiceAreaIds.length > 0) {
          filters.practice_area_ids = practiceAreaIds;
        }

        const response = await listActivityTypes('', count, '', 'forward', filters, excludeFromLoading);
        if (response && response.data && response.data?.activity_types.length > 0) {
          response.data.activity_types.forEach((type) => {
            type.activity_label = type.activity_type + ' - ' + type.activity_type_code;
          });

          setActivityTypes([...response.data.activity_types]);
        }
      } catch (error) {
        console.error('Error loading activity types:', error);
      }
    },
    [totalCount]
  );

  useEffect(() => {
    if (!skipInitialLoad) {
      loadActivityTypes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { activityTypes, loadActivityTypes };
};

export default useActivityTypes;
